module.exports = __webpack_public_path__ + "static/media/Copy.6bb3c6a9.svg";